import React, {useState} from 'react';
import styled from 'styled-components';
import {Cross} from 'components/Ui/Icon';
import {Alert, Form, Input} from 'components/antd';
import {useParams, useHistory} from 'react-router';
import {Button} from 'components/Ui';
import {useFormik} from 'formik';
import {useCreateBlockGroupMemberMutation} from 'api';
import * as Yup from 'yup';

const validateSchema = Yup.object().shape({
  name: Yup.string().required('必須項目です'),
});

export default () => {
  const history = useHistory();
  const {blockGroupId} = useParams<{
    blockGroupId: string;
  }>();
  const [createdError, setCreatedError] = useState(false);

  const closeDetail = () =>
    history.push(
      `/block/block_groups/${blockGroupId}/block_members${location.search}`,
    );

  const [createBlockGroupMember, {loading}] = useCreateBlockGroupMemberMutation(
    {
      refetchQueries: ['blockGroupMembers'],
      onCompleted: ({createBlockGroupMember: {isCreated}}) => {
        if (isCreated) {
          closeDetail();
        } else {
          setCreatedError(true);
        }
      },
    },
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      webSite: '',
      telephoneNumber: '',
      corpNumber: '',
      address: '',
    },
    validationSchema: validateSchema,
    onSubmit: (values) => {
      createBlockGroupMember({
        variables: {
          uuid: blockGroupId,
          attributes: values,
        },
      });
    },
  });

  const {values, isValid, errors, handleChange, handleSubmit} = formik;

  return (
    <Container>
      <Header>
        <Title>ブロックリスト新規作成</Title>
        <CloseButton onClick={closeDetail}>
          <Cross />
        </CloseButton>
      </Header>

      <CustomForm onFinish={handleSubmit}>
        {createdError && (
          <>
            <Alert message="既に同じ企業が存在します。" type="error" />
            <br />
          </>
        )}
        <CustomForm.Item required>
          <Label>会社名</Label>
          <CustomInput
            haserror={errors.name}
            name="name"
            value={values.name}
            onChange={handleChange}
          />
          {!!errors.name && <ErrorMessage>必須です</ErrorMessage>}
        </CustomForm.Item>
        <CustomForm.Item>
          <Label>URL</Label>
          <CustomInput
            name="webSite"
            value={values.webSite}
            onChange={handleChange}
          />
        </CustomForm.Item>
        <CustomForm.Item>
          <Label>TEL</Label>
          <CustomInput
            name="telephoneNumber"
            value={values.telephoneNumber}
            onChange={handleChange}
          />
        </CustomForm.Item>
        <CustomForm.Item>
          <Label>法人番号</Label>
          <CustomInput
            name="corpNumber"
            value={values.corpNumber}
            onChange={handleChange}
          />
        </CustomForm.Item>
        <CustomForm.Item>
          <Label>住所</Label>
          <CustomInput
            name="address"
            value={values.address}
            onChange={handleChange}
          />
        </CustomForm.Item>
        <ButtonWrapper>
          <CustomButton
            htmlType="submit"
            loading={loading}
            disabled={!formik.dirty || !isValid || loading}>
            保存
          </CustomButton>
        </ButtonWrapper>
      </CustomForm>
    </Container>
  );
};

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 605px;
  height: 100%;
  background: #ffffff;
  border-left: 1px solid var(--border-color);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 82px;
  border-bottom: 1px solid var(--border-color);
`;

const Title = styled.div`
  margin-left: 40px;
  font-weight: bold;
  font-size: 18px;
  line-height: 26px;
  color: var(--text-color-2);
`;

const CloseButton = styled.span`
  width: 30px;
  height: 30px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 25px;

  svg {
    margin: 9px;
  }
`;

const CustomForm = styled(Form)`
  padding: 34px 34px 0 58px;
  .ant-form-item {
    margin-bottom: 30px;
  }
`;

const Label = styled.div`
  font-weight: bold;
  font-size: 12px;
  line-height: 17px;
  color: var(--text-color-2);
`;

const CustomInput = styled(Input)<{haserror?: string}>`
  margin-top: 6px;
  font-size: 14px;
  line-height: 26px;
  border: 0.5px solid var(--text-color-3);
  border-radius: 4px;
  border-color ${({haserror}) => (haserror ? '#BA4047' : 'var(--text-color-3)')} !important;
`;

const ErrorMessage = styled.span`
  color: #ba4047;
`;

const ButtonWrapper = styled.div`
  display: flex;
  button {
    margin-left: auto;
  }
`;

const CustomButton = styled(Button)`
  width: 125px;
  height: 45px;
  font-weight: bold;
  font-size: 14px;
`;
